import React, { useState, useEffect } from 'react'
import { Card, Row, Container, CardHeader, Col, CardBody, CardTitle, NavItem, TabContent, NavLink, Nav, CardText, Button,    Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,TabPane, ListGroup, ListGroupItem } from 'reactstrap'
  import { Link, useNavigate } from "react-router-dom";

const TutorStudentClassAtt = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [attendanceData, setAttendanceData] = useState([]);

  useEffect(() => {
    // Dummy data to replace API call
    const dummyData = [
      {
        id: 1,
        studentName: "Rahul Sharma",
        className: "Class 10 CBSE",
        parentName: "Mr. Vikash Sharma",
        subject: "Mathematics",
        topicsSummary: "Quadratic equations, factorization methods, and solving word problems",
        date: "15/01/2024",
        totalTeachingDays: 25
      },
      {
        id: 2,
        studentName: "Priya Gupta",
        className: "Class 12 CBSE",
        parentName: "Mrs. Sunita Gupta",
        subject: "Physics",
        topicsSummary: "Electromagnetic induction, Lenz's law, and practical applications",
        date: "16/01/2024",
        totalTeachingDays: 30
      },
      {
        id: 3,
        studentName: "Arjun Patel",
        className: "Class 9 ICSE",
        parentName: "Mr. Rajesh Patel",
        subject: "Chemistry",
        topicsSummary: "Atomic structure, periodic table trends, and chemical bonding",
        date: "17/01/2024",
        totalTeachingDays: 22
      },
      {
        id: 4,
        studentName: "Sneha Verma",
        className: "Class 11 CBSE",
        parentName: "Dr. Amit Verma",
        subject: "Biology",
        topicsSummary: "Cell division, mitosis and meiosis processes, genetic variations",
        date: "18/01/2024",
        totalTeachingDays: 28
      },
      {
        id: 5,
        studentName: "Karan Singh",
        className: "Class 8 State Board",
        parentName: "Mrs. Meera Singh",
        subject: "Science",
        topicsSummary: "Light and reflection, mirrors, lenses, and optical instruments",
        date: "19/01/2024",
        totalTeachingDays: 20
      }
    ];

    setTimeout(() => {
      setAttendanceData(dummyData);
      setIsLoading(false);
    }, 1000);
  }, []);

  return (
    <div>
      <div style={{ overflowX: 'auto' }}>
        <Table hover>
          <thead>
            <tr style={{ background: "#F6F9FC" }}>
              <th id="tableheding">S.NO</th>
              <th id="tableheding">Student Name</th>
              <th id="tableheding">Student's Class Name</th>
              <th id="tableheding">Parent's Name</th>
              <th id="tableheding">Subject</th>
              <th id="tableheding">Taught Topics Summary</th>
              <th id="tableheding">Date</th>
              <th id="tableheding">Total Teaching Day in Cycle</th>
            </tr>
          </thead>
          <tbody>
            {!isLoading ? (
              attendanceData.length > 0 ? (
                attendanceData.map((item, index) => (
                  <tr key={item.id} style={{ cursor: "pointer" }}>
                    <td id="tabledata">{index + 1}</td>
                    <td id="tabledata">{item.studentName}</td>
                    <td id="tabledata">{item.className}</td>
                    <td id="tabledata">{item.parentName}</td>
                    <td id="tabledata">{item.subject}</td>
                    <td id="tabledata">{item.topicsSummary}</td>
                    <td id="tabledata">{item.date}</td>
                    <td id="tabledata">{item.totalTeachingDays}</td>
                  </tr>
                ))
              ) : (
                <tr style={{ textAlign: "center" }}>
                  <td colSpan="8" style={{ verticalAlign: "middle" }}>
                    No data found
                  </td>
                </tr>
              )
            ) : (
              <tr style={{ textAlign: "center" }}>
                <td colSpan="8" style={{ verticalAlign: "middle" }}>
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <br />
    </div>
  )
}

export default TutorStudentClassAtt
